import { create } from 'zustand';
import apiClient from '../api/client';

interface UserInfo {
  email: string;
  name: string;
  picture: string;
}

interface AuthState {
  user: UserInfo | null;
  loading: boolean;
  error: string | null;
  fetchUser: () => Promise<void>;
  logout: () => Promise<void>;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  loading: false,
  error: null,

  fetchUser: async () => {
    set({ loading: true, error: null });
    try {
      const user = await apiClient.get<UserInfo>('/api/auth/me');
      set({ user, loading: false });
    } catch (err) {
      set({ error: (err as Error).message, loading: false });
    }
  },

  logout: async () => {
    try {
      await apiClient.post('/api/auth/logout');
    } catch {
      // ignore
    }
    apiClient.clearAuthToken();
    set({ user: null });
    window.location.href = '/login';
  },
}));
